import React, { memo, useCallback } from 'react';

import { Product } from 'types/graphql-overrides';

import { useProductCardData } from './use-product-card-data';
import { FullCardView } from './views/full-card-view';

type ProductListItemProps = {
  product: Product;
  productIndex: number;
  onView?: (product: Product, index: number) => void;
  onClick: (product: Product, index: number) => void;
  onAddToCart: (product: Product, index: number, option: string) => void;
  hideBorder?: boolean;
};

/**
 * Container for the list product card.
 * Owns data fetching and action binding; delegates rendering to FullCardView.
 */
const FullCard = ({
  product,
  productIndex,
  onView,
  onClick,
  onAddToCart,
  hideBorder = false,
}: ProductListItemProps): JSX.Element => {
  const data = useProductCardData({
    product,
    productIndex,
    onView,
  });

  const handleLinkClick = useCallback((): void => {
    onClick(product, productIndex);
  }, [onClick, product, productIndex]);

  const handleOptionClick = useCallback(
    (value: string): void => {
      onAddToCart(product, productIndex, value);
    },
    [onAddToCart, product, productIndex]
  );

  return (
    <FullCardView
      product={data.product}
      image={data.image}
      badges={data.badges}
      options={data.options}
      layout={{ hideBorder }}
      onLinkClick={handleLinkClick}
      onOptionClick={handleOptionClick}
      containerRef={data.containerRef}
      productIndex={data.productIndex}
    />
  );
};

export default memo(FullCard);
